import React from 'react'
import { connect } from 'react-redux'
import { isEmpty } from 'lodash'
import { fetchSets, addSets, sortSets, searchSets } from "../../actions/settings"
import SetsEtypeItem from "./SetsEtypeItem"
import SettingsForm from './SettingsForm'

class SetsEtype extends SettingsForm {

  modelName = 'etype'

  newItem = {
    etype_desc: '',
    etype_active: 1
  };

  render() {
    if(isEmpty(this.props.etypes.data)){
      return(<div>Не загружены данные</div>);
    }
    const etypes = this.props.etypes.data;
    const { search, sort } = this.props.etypes;
    const { data, errors } = this.state;

    var fltrEtypes = [];
    for(var key in etypes){
      if(etypes.hasOwnProperty(key)){
        const active = etypes[key].etype_active === 1;
        var found = true;
        if(search !== ''){
          const searchValue = "" + etypes[key].etype_desc;
          found = searchValue.toLowerCase().indexOf(search) !== -1;
        }
        if(active && found){
          fltrEtypes.push(etypes[key]);
        }
      }
    }

    const srtEtypes = fltrEtypes.sort( (a, b) => {
      if(a[sort.field] < b[sort.field])
         return sort.asc ? -1 : 1
      if(a[sort.field] > b[sort.field])
         return sort.asc ? 1 : -1
      if(a.etype_id < b.etype_id)
         return sort.asc ? -1 : 1
      if(a.etype_id > b.etype_id)
         return sort.asc ? 1 : -1
      return 0
    });

    const mappedEtypes = srtEtypes ? srtEtypes.map(etype =>
      <SetsEtypeItem key={etype.etype_id}
        data={etype}
      />
    ) : [];

    const addNew = this.state.adding ?
      <tr>
        <td>
          <div className="form-group">
            <input type="text"
              className="form-control"
              value={data.etype_desc}
              name="etype_desc"
              onChange={this.updateInput}
              placeholder="Название"
              autoFocus
            />
          </div>
          <div className="form-inline">
            <button  type="button" className="btn btn-success"
              onClick={this.saveItem} title="Сохранить">
              <span className="glyphicon glyphicon-save"></span>
            </button>{" "}
            <button type="button" className="btn btn-default"
              onClick={this.cancelAdding} title="Отменить">
              <span className="glyphicon glyphicon-remove"></span>
            </button>
            {errors.form && <div className="alert alert-danger">{errors.form}</div>}
          </div>
        </td>
      </tr>
      :[];


    return (
      <div>
        <h3 className="pull-right">Настройка направлений</h3>
        <div className="form-group form-inline">
          <button className="btn btn-primary" onClick={this.startAdding}>Создать</button>
          {" "}
          <div className="input-group">
            <input
              type="search"
              className="form-control"
              value={search}
              title="Поиск"
              placeholder="Поиск"
              onChange={this.handleSearch} />
            <div className="input-group-btn">
              <button
                type="button"
                className="btn btn-default"
                onClick={this.clearSearch}
                title="Очистить поиск">
                X
              </button>
            </div>
          </div>{" "}
          <div className="input-group">{fltrEtypes.length} записей</div>
        </div>
        <table className="table table-striped table-hover sticky-50">
          <thead>
            <tr style={{cursor:'pointer'}}>
              <th onClick={() => {this.handleSort('etype_desc')}}>Название</th>
            </tr>
          </thead>
          <tbody>
            {addNew}
            {mappedEtypes}
            <tr onClick={this.startAdding}>
              <td><u>Нажмите, чтобы добавить запись</u></td>
            </tr>
          </tbody>
        </table>
      </div>
    )

  }
}

function mapOrdersToProps(store) {
  return {
    etypes: store.etypes
  }
}

export default connect(mapOrdersToProps, { fetchSets, addSets, sortSets, searchSets })(SetsEtype);



// WEBPACK FOOTER //
// ./src/components/settings/SetsEtype.js